<template>
  <!-- <button @click="restartAnimation" style="position: fixed; top: 10; z-index: 99999999;">重新播放</button> -->
  <div ref="container" class="three-container"></div>
</template>

<script>
import * as THREE from 'three';
import { onMounted, onBeforeUnmount, ref } from 'vue';
import { eventBus } from "@/utils/eventBus"

export default {
  setup() {

    const container = ref(null);
    let scene, camera, renderer, mesh, texture;
    let animationId = null;
    let currentFrame = 0;
    let lastFrameTime = 0;
    let frameInterval = 1000 / 150; // 初始间隔(ms)
    let isReverse = false; // 是否反向播放
    let fadeOut = false; // 是否开始淡出
    let fadeAlpha = 1; // 透明度

    // 纹理参数
    const textureParams = {
      totalWidth: 9216,     // 纹理总宽度
      totalHeight: 4608,    // 纹理总高度
      cols: 9,             // 横向帧数
      rows: 8,             // 纵向帧数
      frameWidth: 1024,     // 单帧宽度
      frameHeight: 576,     // 单帧高度
      totalFrames: 9 * 8    // 总帧数 (9x8=72帧)
    };

    // 初始化场景
    const initScene = () => {
      // 创建场景
      scene = new THREE.Scene();

      // 创建相机
      camera = new THREE.PerspectiveCamera(
        64,
        container.value.clientWidth / container.value.clientHeight,
        0.2,
        1000
      );
      camera.position.z = 6;

      // 创建渲染器
      renderer = new THREE.WebGLRenderer({ antialias: true, alpha: true });
      renderer.setSize(container.value.clientWidth, container.value.clientHeight);
      container.value.appendChild(renderer.domElement);

      // 创建纹理
      texture = new THREE.TextureLoader().load(`${process.env.VUE_APP_CDN_URL}/texture/text3D-03.png`);
      texture.wrapS = THREE.RepeatWrapping;
      texture.wrapT = THREE.RepeatWrapping;

      // 计算UV重复比例
      texture.repeat.set(
        1 / textureParams.cols,  // 水平方向显示1/9
        1 / textureParams.rows   // 垂直方向显示1/8
      );

      // 创建材质
      const material = new THREE.MeshBasicMaterial({
        map: texture,
        transparent: true,
        opacity: 1
      });

      // 创建几何体 - 根据帧的宽高比设置
      const aspect = textureParams.frameWidth / textureParams.frameHeight;
      const geometry = new THREE.PlaneGeometry(4 * aspect, 4);

      // 创建网格
      mesh = new THREE.Mesh(geometry, material);
      scene.add(mesh);

      // 添加窗口大小变化监听
      window.addEventListener('resize', onWindowResize);
    };

    // 更新纹理偏移到指定帧
    const updateTextureFrame = (frame) => {
      const col = frame % textureParams.cols;  // 列索引 (0-8)
      const row = Math.floor(frame / textureParams.cols); // 行索引 (0-7)

      // 计算偏移量 (从左到右，从上到下)
      texture.offset.x = col / textureParams.cols;
      texture.offset.y = 1 - (row + 1) / textureParams.rows; // THREE.js纹理坐标Y轴是反的
    };



    // 动画循环
    const animate = (timestamp) => {
      animationId = requestAnimationFrame(animate);
      //console.log(animationId)
      if (timestamp - lastFrameTime > frameInterval) {
        if (!fadeOut) {
          // 正常播放或反向播放
          if (!isReverse) {
            currentFrame++;
            if (currentFrame >= textureParams.totalFrames - 1) {
              isReverse = true; // 到达最后一帧，开始反向播放
              //console.log('0')
              eventBus.emit('model_start', 'reset')
            }
          } else {
            currentFrame--;
            if (currentFrame <= 0) {
              fadeOut = true; // 回到第一帧，开始淡出
            }
          }
        } else {
          // 淡出效果
          fadeAlpha = Math.max(0, fadeAlpha - 0.02);
          mesh.material.opacity = fadeAlpha;

          if (fadeAlpha <= 0) {
            // 淡出完成，重置状态
            fadeOut = false;
            isReverse = false;
            fadeAlpha = 1;
            mesh.material.opacity = 1;
            currentFrame = 0;
            //console.log('1')
            eventBus.emit('model_end', 'reset')

            cancelAnimationFrame(animationId); // 停止动画循环
            animationId = null;
            //console.log(2)
            return; // 提前退出，防止继续渲染
          }
        }
        //console.log('currentFrame:'+ currentFrame)
        updateTextureFrame(currentFrame);
        lastFrameTime = timestamp;
        //console.log(lastFrameTime);
      }

      renderer.render(scene, camera);
    };

    // 处理窗口大小变化
    const onWindowResize = () => {
      camera.aspect = container.value.clientWidth / container.value.clientHeight;
      camera.updateProjectionMatrix();
      renderer.setSize(container.value.clientWidth, container.value.clientHeight);
    };

    const restartAnimation = () => {
      // 重置所有状态
      //debugger
      //alert(1)
      console.log('restartAnimation')
      currentFrame = 0;
      isReverse = false;
      fadeOut = false;
      fadeAlpha = 1;

      // 重置纹理位置和透明度
      updateTextureFrame(currentFrame);
      if (mesh) {
        mesh.material.opacity = 1;
      }

      // 如果动画已经停止，重新启动
      if (!animationId) {
        console.log(333)
        lastFrameTime = performance.now();
        animate();
      }
    };

    // 组件挂载时初始化
    onMounted(() => {
      initScene();

      lastFrameTime = performance.now();
      //animate();
      //restartAnimation()
      eventBus.on('playAnimate', restartAnimation)
      //eventBus.on('message', restartAnimation); // 监听重新播放事件
    });

    // 组件卸载前清理
    onBeforeUnmount(() => {
      if (animationId) cancelAnimationFrame(animationId);
      window.removeEventListener('resize', onWindowResize);
      if (renderer) renderer.dispose();
      if (texture) texture.dispose();
      if (mesh && mesh.geometry) mesh.geometry.dispose();
      if (mesh && mesh.material) mesh.material.dispose();
      if (container.value && renderer?.domElement) {
        container.value.removeChild(renderer.domElement);
      }
    });

    return {
      container,
      restartAnimation
    };
  }
};
</script>

<style scoped>
.three-container {
  width: 100%;
  height: 100%;
  position: absolute;
  overflow: hidden;
  /* background-color: #ff6600; */
}
</style>